import { FC, SVGProps } from "react";

const BackpackIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" stroke="currentcolor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round" {...props}>
      <path
        d="M15 21V12H9V21M15 16H9M15 9H9M15 6.03838V6C15 5.06812 15 4.60218 14.8478 4.23463C14.6448 3.74458 14.2554 3.35523 13.7654 3.15224C13.3978 3 12.9319 3 12 3C11.0681 3 10.6022 3 10.2346 3.15224C9.74458 3.35523 9.35523 3.74458 9.15224 4.23463C9 4.60218 9 5.06812 9 6V6.03838M15 6.03838C14.3714 6 13.5965 6 12.6 6H11.4C10.4035 6 9.62856 6 9 6.03838M15 6.03838C15.7844 6.08627 16.3409 6.19394 16.816 6.43597C17.5686 6.81947 18.1805 7.43139 18.564 8.18404C19 9.03969 19 10.1598 19 12.4V17.8C19 18.9201 19 19.4802 18.782 19.908C18.5903 20.2843 18.2843 20.5903 17.908 20.782C17.4802 21 16.9201 21 15.8 21H8.2C7.07989 21 6.51984 21 6.09202 20.782C5.71569 20.5903 5.40973 20.2843 5.21799 19.908C5 19.4802 5 18.9201 5 17.8V12.4C5 10.1598 5 9.03969 5.43597 8.18404C5.81947 7.43139 6.43139 6.81947 7.18404 6.43597C7.65905 6.19394 8.21558 6.08627 9 6.03838"
        
      />
    </svg>
  );
};

export default BackpackIcon;
